import { HttpClient, HttpContext, HttpContextToken } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { forkJoin, Observable, of } from 'rxjs';

export const BYPASS_AUTH = new HttpContextToken(() => false);

@Injectable({
  providedIn: 'root'
})
export class UploadDocumentoService {

  constructor(private readonly http: HttpClient) { }

  UploadDocumento(urlPreAssinada: string | string[], arquivo: File | File[]): Observable<any> {

    if (typeof urlPreAssinada === 'string' && arquivo instanceof File) {
      return this.http.put(urlPreAssinada, arquivo, {
        responseType: 'text',
        context: new HttpContext().set(BYPASS_AUTH, true)
      });
    }

    if (Array.isArray(urlPreAssinada) && Array.isArray(arquivo)) {
      let uploads = urlPreAssinada.map((url, i) =>
        this.http.put(url, arquivo[i], {
          responseType: 'text',
          context: new HttpContext().set(BYPASS_AUTH, true)
        })
      );
      return forkJoin(uploads);
    }
    return of(null);
  }
}